import { type FC, useMemo } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { RichText } from '@vakantiesnl/components/src/molecules/RichText';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { useRichText } from '@vakantiesnl/services/src/hooks/contentful';
import { useFilterStore } from '@vakantiesnl/services/src/stores/filtersStore';
import { type MicroCopy } from '@vakantiesnl/types';

import { useStyles } from './EmptyState.style';

const noResultsRichText = {
	['fields.key[in]']: ['accommodation.noresults.content'],
};

type Props = {
	microCopies: MicroCopy;
};

export const EmptyState: FC<Props> = ({ microCopies }) => {
	const { isTabletOrIsDesktop } = useBreakpoints();

	const { classes } = useStyles();
	const richTextElements = useRichText(noResultsRichText);
	const content = useMemo(
		() => (richTextElements ? richTextElements['accommodation.noresults.content'] : undefined),
		[richTextElements],
	);

	const onClear = useFilterStore((s) => s.clearFilters);

	return (
		<div className={classes.emptyState}>
			<Typography
				as="h2"
				variant={isTabletOrIsDesktop ? 'headingLg' : 'headingSm'}
				className={classes.noResultsHeader}
			>
				{microCopies['accommodation.noresults.title']}
			</Typography>
			{content && <RichText document={content} />}
			<Button
				variant="primary"
				size={isTabletOrIsDesktop ? 'medium' : 'small'}
				onClick={onClear}
				data-cy="accopage-noresults"
			>
				{microCopies['filters.clear']}
			</Button>
		</div>
	);
};
